import { render, staticRenderFns } from "./DateTimeRangePopup.vue?vue&type=template&id=bc33139e&"
import script from "./DateTimeRangePopup.vue?vue&type=script&lang=js&"
export * from "./DateTimeRangePopup.vue?vue&type=script&lang=js&"
import style0 from "./DateTimeRangePopup.vue?vue&type=style&index=0&id=bc33139e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCheckbox,QSelect});
